<div class="alert alert-danger" *ngIf="entity?.goalWarns?.length > 0">
  <h5>Inconsistências: </h5>
  <ol>
    <li *ngFor="let warning of entity?.goalWarns">{{ warning }}</li>
  </ol>
</div>

<form [formGroup]="form">
  <div class="system-table table-container table-form">
    <div class="system-table-conteiner system-table-form-conteiner">
      <table>
        <thead>
          <tr>
            <th>Ano</th>
            <th class="text-center">Meta</th>
          </tr>
        </thead>
        <tbody formArrayName="goals">
          <ng-container *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
            <tr>
              <td class="title">{{ item?.value?.year }}</td>
              <td>
                <div class="form-group">
                  <div class="col-sm-12">
                    <input type="text" class="form-control text-right" formControlName="goal" (keyup)="formatarMedidaFisica(i, 'goal')">
                  </div>
                </div>
              </td>
            </tr>
          </ng-container>
          <tr *ngIf="!entity?.accum">
            <td class="title"><strong>Total</strong></td>
            <td class="text-right">{{ entity?.goalSum }}</td>
          </tr>
          <tr>
            <td class="title"><strong>Valor Meta Global</strong></td>
            <td class="text-right">{{ entity?.goal }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</form>

<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
    <button *ngIf="entity?.goalEdit && !this.entity?.readonly" class="btn btn-primary" type="button" (click)="salvar()">Salvar</button>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>